import React from 'react';
import {
  SUBTITLE_NO_OPTIONS,
  SUBTITLE_OPTIONS,
  SUGGESTION_AVAILABLE,
  SUGGESTION_TEXT,
} from '../constants';

export default function buildModalTitle(modalType: string | undefined) {
  const subtitleText = modalType === SUGGESTION_AVAILABLE ? SUBTITLE_OPTIONS : SUBTITLE_NO_OPTIONS;

  const suggestionText = modalType === SUGGESTION_AVAILABLE ? SUGGESTION_TEXT : '';
  return (
    <div className="av__title-cont">
      <p className="av__title">Oops! Please Verify</p>
      <p className="av__subtitle">{subtitleText}</p>
      <p className="av__tip">{suggestionText}</p>
    </div>
  );
}
